<template>
    <v-app-bar class="px-5 py-2" jusitfy="center" color="#f3f6fa" height="64">
        <div class="mx-auto">
            <a :href="$system.systemSettings.logo_link" target="_blank">
                <v-img v-if="$system.systemSettings.dark_logo_name" :src="$system.systemSettings.dark_logo_name" height="45" width="200"></v-img>
                <v-img v-else src="@/assets/img/logo.svg" height="45" width="200"></v-img>
            </a>
        </div>
    </v-app-bar>
    <v-main class="app-background position-relative">
        <v-container class="h-100 d-flex align-center" fluid>
            <v-fade-transition>
                <v-row align="center" justify="center">
                    <v-col lg="9" md="10" sm="11">
                        <v-card class="rounded mx-auto overflow-visible helpical-shadow" style="max-width:900px !important;">
                            <div class="d-flex">
                                <div class="my-n10 ps-7 d-none d-md-block" cols="auto">
                                    <v-img src="@/assets/img/auth-poster.png" class="rounded" height="520" width="230"></v-img>
                                </div>
                                <div class="pa-4 pa-sm-10 d-flex align-center justify-center flex-grow-1">
                                    <slot />
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-fade-transition>
            <div class="text-center pb-1" style="position:fixed;bottom:0;right:0;left:0;border-top:1px solid #00000020;width:100%">
                <a target="_blank" href="https://www.helpical.com" class="text-grey text-small font-weight-medium text-decoration-none">نرم‌افزار هلپ دسک و تیکتینگ هلپیکال </a>
                <a target="_blank" href="https://www.helpical.com/changelog" class="text-grey text-small font-weight-medium text-decoration-none">نسخه {{ $system.systemSettings.version }}</a>
            </div>
        </v-container>
    </v-main>
</template>

<script>
</script>

<style lang="scss" scoped>
.app-background::before {
    content: "";
    position: absolute;
    width: 70%;
    top: 0;
    bottom: 0;
    right: 0;
    background-image: url("@/assets/img/auth-layout-background.png");
    background-size: cover;
}
</style>
